<template>
  <div class="main_div">
    <section id="container" class="gnb_pdt">
      <div class="title_wrap">
        <h1 class="f_l">사용자 목록</h1>
        <div style="text-align:right; font-size:23px; float:right; line-height: 42px;">
          <button class="large_btn orange" style="width:100px; float:right; margin-left:10px;"
                  @click="onClickRefresh"
          > 새로고침
          </button> {{ lastRenderingTime }}
          <kendo-switch
              ref="autoYnRef"
              :messages-checked="'자동'"
              :messages-unchecked="'수동'"
              :checked="autoRender"
              @change="setAutoRender"
          >
          </kendo-switch>
        </div>
      </div>
      <div class="contents_wrap mg0">
        <div class="content_list">
          <div class="button_wrap_area">
            <ul>
              <li>
                <button class="large_btn orange" @click="commonOnChangeEvent">검색</button>
              </li>
              <li>
                <button class="large_btn" @click="cleanSearchDataEvent">초기화</button>
              </li>
            </ul>
          </div>
          <div id="filter_section" class="filter_wrap">
            <ul class="filter_list">
              <li class="col2">
                <dd>
                  <label>사업장</label>
                  <ul>
                    <li>
                      <kendo-dropdownlist
                          class="w100"
                          ref="facilityRef"
                          :data-source="zone1DepthList"
                          :value="lastRouteParams.facilityId"
                          :data-text-field="'cdNm'"
                          :data-value-field="'cdId'"
                          :option-label="'전체'"
                          :no-data-template="'표시할 데이터가 없습니다.'"
                          @change="onChangeFacility"
                      >
                      </kendo-dropdownlist>
                    </li>
                  </ul>
                </dd>
                <dd>
                  <label>거점</label>
                  <ul>
                    <li>
                    <li>
                      <kendo-dropdownlist
                          class="w100"
                          ref="areaRef"
                          :data-source="zone2DepthList"
                          :value="lastRouteParams.areaId"
                          :data-text-field="'cdNm'"
                          :data-value-field="'cdId'"
                          :option-label="'전체'"
                          :no-data-template="'표시할 데이터가 없습니다.'"
                          @change="commonOnChangeEvent"
                      >
                      </kendo-dropdownlist>
                    </li>
                  </ul>
                </dd>
              </li>
              <li class="col2">
                <dd>
                  <label>계정 권한</label>
                  <ul>
                    <li>
                      <kendo-buttongroup
                          ref="authRef"
                          @select="commonOnChangeEvent"
                          :style="{width: '100%', border: '0'}"
                          :value="lastRouteParams.authId"
                          :data-source="authList"
                      >
                        <kendo-buttongroup-button
                            v-for="item in authList"
                            v-bind:key="item.authNm">
                          {{item.authNm}}
                        </kendo-buttongroup-button>
                      </kendo-buttongroup>
                    </li>
                  </ul>
                </dd>
                <dd>
                  <label>계정 상태</label>
                  <ul>
                    <li>
                      <kendo-buttongroup
                          ref="useYnRef"
                          @select="commonOnChangeEvent"
                          :style="{width: '100%', border: '0'}"
                          :value="lastRouteParams.useYn"
                          :data-source="userStatusList"
                      >
                        <kendo-buttongroup-button
                            v-for="item in userStatusList"
                            v-bind:key="item.cdId">
                          {{item.cdNm}}
                        </kendo-buttongroup-button>
                      </kendo-buttongroup>
                    </li>
                  </ul>
                </dd>
              </li>
              <li class="col2">
                <dd>
                  <label>통합검색</label>
                  <ul>
                    <li>
                      <kendo-maskedtextbox
                          ref="searchRef"
                          id="search"
                          :value="lastRouteParams.search"
                          :style="'width: 100%;'"
                          :placeholder="'ID, 성명, 휴대전화번호, 이메일을 입력하세요.'">
                      </kendo-maskedtextbox>
                    </li>
                  </ul>
                </dd>
                <dd>
                  <label>회사</label>
                  <ul>
                    <li>
                      <kendo-multicolumncombobox
                          ref="cmpyIdRef"
                          :data-source="cmpyList"
                          :value="lastRouteParams.cmpyId"
                          :data-text-field="'cmpyNm'"
                          :data-value-field="'cmpyId'"
                          :filter="'contains'"
                          :no-data-template="'표시할 데이터가 없습니다.'"
                          class="w100"
                          :index = 0
                          @change="commonOnChangeEvent"
                      >
                      </kendo-multicolumncombobox>
                    </li>
                  </ul>
                </dd>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="dblock mgt20" v-if="isSU">
        <div class="c_t_button_wrap f_l">
          <button v-show="isEtners" class="mid_btn orange" @click="onClickUserSave"><span>사용자 등록</span></button>
        </div>
      </div>
      <!-- 리스트 영역 -->
      <kendo-grid ref="userListGridRef"
                  id="grid"
                  class="basic_table mgt10"
                  :data-source="userListDataSource"
                  :columns="userListColumns"
                  :navigatable="true"
                  :filterable="false"
                  :sortable="true"
                  :scrollable="true"
                  :pageable-always-visible="true"
                  :pageable-page-sizes="[5, 10, 20, 50, 100, 500, 1000]"
                  :reorderable="true"
                  :column-menu="false"
                  :resizable="true"
                  :selectable="'multiple row'"
                  @change="onChangeEventGrid"
                  :noRecords="{ template: '<div class=\'gridNoData\' style=\'text-align: center;\'>표시할 데이터가 없습니다.</div>' }">
      </kendo-grid>
    </section>
  </div>
</template>

<script>
import ApiConfig from '@/api/api.config'
import EtnersCommonUtil from '@/common/etners.common.util'
import { LogisticsCodeDtlMixin, ZoneMixin } from '@/mixin/Mixin'
import EtnersParseUtil from '@/common/etners.parse.util'

export default {
  name: 'UserList',
  mixins: [ LogisticsCodeDtlMixin, ZoneMixin ],
  mounted: function () {
    const vm = this
    const refs = vm.$refs

    const jsonStrLastRouteParams = sessionStorage.getItem('LAST_ROUTE_PARAMS')
    vm.lastRouteParams = sessionStorage.getItem('LAST_ROUTE_NAME') === 'UserDetail' || 'UserUpdate' ? (jsonStrLastRouteParams === undefined ? [] : JSON.parse(jsonStrLastRouteParams)) : []
    if(EtnersCommonUtil.isNotEmpty(vm.lastRouteParams)) {
      vm.lastRouteParams.filter = EtnersCommonUtil.getLastRouteParams(vm.lastRouteParams)
    }
    vm.getUserList()

    // 권한, 상태 설정
    refs.authRef.kendoWidget().select(0)
    refs.useYnRef.kendoWidget().select(0)
    if (EtnersCommonUtil.isNotEmpty(vm.lastRouteParams.authId)){
      const id = vm.authList.findIndex(v => v.authId === vm.lastRouteParams.authId)
      refs.authRef.kendoWidget().select(id)
    }
    if (EtnersCommonUtil.isNotEmpty(vm.lastRouteParams.useYn)) {
      const id = vm.userStatusList.findIndex(v => v.cdId === vm.lastRouteParams.useYn)
      refs.useYnRef.kendoWidget().select(id)
    }

    // 사업장
    vm.onChange1Depth('facilityRef')
    // 거점
    vm.$refs.areaRef.kendoWidget().setDataSource(vm.zone2DepthList)
    vm.$refs.areaRef.kendoWidget().value(vm.lastRouteParams.areaId)

    vm.commonOnChangeEvent()

    const enterkeyEventTargetIdArray = [
      'search'
    ]
    for (const elementId of enterkeyEventTargetIdArray) {
      const element = document.getElementById(elementId)
      if (element !== undefined) {
        element.onkeyup = function (e) {
          const ENTER_KEY_CODE = 13
          const currentKeyCode = window.event.keyCode
          if (currentKeyCode === ENTER_KEY_CODE) {
            vm.commonOnChangeEvent(e)
          }
        }
      }
    }
  },
  data: function() {
    const vm = this
    const kendoGridHeaderAttributes = {
      style: 'font-weight: bold; text-align : center;'
    }

    const now = new Date()

    let cmpyList = [{cmpyId: '', cmpyNm: '전체', corporateRegNo: ''}]
    let cmpyCdDtl = vm.$store.state.codeRequestStore.search.combobox.cmpyNmForUser.data
    for (let a of cmpyCdDtl) {
      cmpyList.push(a)
    }

    const loginUserData = sessionStorage.getItem('loginUserData')
    let loginUserObj = JSON.parse(loginUserData)
    const isEtners = (loginUserObj.authId === '9999') || (loginUserObj.authId === '1001') ? true : false

    let authList = [{authId: '', authNm: '전체'}]
    let authCdDtl = this.$store.state.codeRequestStore.search.combobox.authNm.data
    for (let a of authCdDtl) {
      if(a.authId === '1001' || a.authId === '2001' ||a.authId === '9999'){
        authList.push(a)
      }
    }
    // [authList[2], authList[3]] = [authList[3], authList[2]]

    const isSU = loginUserObj.authId === '9999'

    return {
      loginUserToken: sessionStorage.getItem('loginUserToken'),
      loginUserData: loginUserObj,
      isSU: isSU,
      isEtners: isEtners,
      lastRouteParams: [],
      lastRenderingTime: EtnersParseUtil.convertDateToStringYYYYMMDDHHMISSFormat(now),
      intervalSetting: undefined,
      autoRender: false,
      authList : authList,
      cmpyList : cmpyList,
      userListDataSource: [],
      userListColumns: [
        {
          field: 'rowNumber',
          title: 'No.',
          width: '5%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          },
          sortable: false
        },
        {
          field: 'cmpyId',
          title: '회사',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          },
          template(dataItem) {
            return !!dataItem.cmpyNm ? dataItem.cmpyNm : '-'
          },
        },
        {
          field: 'facilityId',
          title: '사업장',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          },
          template(dataItem) {
            return !!dataItem.facilityNm ? dataItem.facilityNm : '-'
          },
        },
        {
          field: 'areaId',
          title: '거점',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          },
          template(dataItem) {
            return !!dataItem.areaNm ? dataItem.areaNm : '-'
          },
        },
        {
          field: 'authId',
          title: '계정 권한',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          },
          template(dataItem) {
            return !!dataItem.authNm ? dataItem.authNm : '-'
          },
        },
        {
          field: 'userId',
          title: 'ID',
          width: '15%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          },
          template(dataItem) {
            return !!dataItem.userId ? dataItem.userId : '-'
          },
        },
        {
          field: 'userNm',
          title: '성명',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          },
          template(dataItem) {
            return !!dataItem.userNm ? dataItem.userNm : '-'
          },
        },
        {
          field: 'spTelNo',
          title: '휴대전화번호',
          width: '10%',
          template: "#= (spTelNo === null) ? '-' : spTelNo.replace(/(\\d{3})(\\d{4})(\\d{4})/, '$1-$2-$3') #",
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'email',
          title: '이메일 주소',
          width: '15%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          },
          template(dataItem) {
            return !!dataItem.email ? dataItem.email : '-'
          },
        },
        {
          field: 'useYn',
          title: '계정상태',
          width: '5%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          },
          template(dataItem) {
            return !!dataItem.useYn ? dataItem.useYn : '-'
          },
        },
        {
          field: 'frstRgstId',
          title: '등록자 ID',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          },
          template(dataItem) {
            return !!dataItem.frstRgstId ? dataItem.frstRgstId : '-'
          },
        },
        {
          field: 'frstRgstDt',
          title: '등록일시',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          },
          template(dataItem) {
            return !!dataItem.frstRgstDt ? dataItem.frstRgstDt : '-'
          },
        },
      ],
    }
  },
  methods: {
    // 자동 새로고침
    setAutoRender () {
      const vm = this
      vm.autoRender = !vm.autoRender
      if(vm.autoRender){
        vm.intervalSetting = window.setInterval(() => {
              vm.commonOnChangeEvent()
              vm.lastRenderingTime = EtnersParseUtil.convertDateToStringYYYYMMDDHHMISSFormat(new Date())
            }, 300000
        );
      }else{
        window.clearInterval(vm.intervalSetting);
      }
    },
    onChangeFacility () {
      const vm = this
      vm.onChange1Depth('facilityRef')
      vm.$refs.areaRef.kendoWidget().setDataSource(vm.zone2DepthList)
      vm.$refs.areaRef.kendoWidget().value(vm.lastRouteParams.areaId)
      vm.commonOnChangeEvent()
    },
    // 사업장 세팅
    // onChangeFacility () {
    //   const vm = this
    //   if (!!vm.$refs.facilityRef) {
    //     vm.facilityList = {
    //       idList: vm.$refs.facilityRef.kendoWidget().value(),
    //       nmList: vm.$refs.facilityRef.kendoWidget().dataItems()
    //     }
    //
    //     // zone2Depth 초기화
    //     let zone1DepthList = []
    //     vm.facilityList.idList.forEach(item => {
    //       zone1DepthList = [
    //         ...zone1DepthList,
    //         ...(!!vm.zone2DepthMap.get(item) ? vm.zone2DepthMap.get(item) : [])
    //       ]
    //     })
    //
    //     vm.$refs.areaRef.kendoWidget().setDataSource(zone1DepthList)
    //     vm.$refs.areaRef.kendoWidget().value(zone1DepthList)
    //     vm.onChangeArea()
    //   }
    // },
    // onChangeArea () {
    //   const vm = this
    //   if (!!vm.$refs.areaRef) {
    //     vm.areaList = {
    //       idList: vm.$refs.areaRef.kendoWidget().value(),
    //       nmList: vm.$refs.areaRef.kendoWidget().dataItems()
    //     }
    //   }
    // },
    // 사용자 목록
    getUserList: function () {
      const vm = this
      const refs = vm.$refs
      vm.lastRouteParams = vm.lastRouteParams === null ? {} : vm.lastRouteParams
      const lastRequestParameterPage = vm.lastRouteParams.page !== undefined ? vm.lastRouteParams.page : 1
      const lastRequestParameterPageSize = vm.lastRouteParams.pageSize !== undefined ? vm.lastRouteParams.pageSize : 10
      vm.userListDataSource = new kendo.data.DataSource({
        name: 'userListDataSource',
        page: lastRequestParameterPage,
        pageSize: lastRequestParameterPageSize,
        serverPaging: true,
        serverFiltering: true,
        serverSorting: true,
        transport: {
          read: {
            url: `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/user/getUserList.json`,
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json',
            cache: false
          },
          parameterMap: function(options, operation) {
            if (operation === 'read') {
              const paramToKendoFilters = vm.currentPageFilterOption()
              // const integrationCustomFilters = paramToKendoFilters

              const readParam = {
                loginUserToken: vm.loginUserToken,
                skip: options.skip,
                take: options.take,
                sort: options.sort,
                page: options.page,
                pageSize: options.pageSize,
                useYn: paramToKendoFilters.useYn,
                cmpyId: paramToKendoFilters.cmpyId,
                facilityId: paramToKendoFilters.facilityId,
                authId: paramToKendoFilters.authId,
                areaId: paramToKendoFilters.areaId,
                search: paramToKendoFilters.search,
                requestType: 'PAGING' // PAGING or EXPORT
              }

              sessionStorage.setItem('LAST_ROUTE_PARAMS', kendo.stringify(readParam))
              return kendo.stringify(readParam)
            }
          }
        },
        batch: true,
        schema: {
          parse: function (response) {
            if (response.resultStatus.messageCode !== '2000') {
              kendo.alert('message: ' + response.resultStatus.messageText)
              return false
            }

            const changeResultData = response.resultData
            let rowNumber = response.total > 1 ? response.total - ((vm.$refs.userListGridRef.dataSource.page() - 1) * vm.$refs.userListGridRef.dataSource.pageSize()) : response.total

            if (changeResultData === null) {
              return false
            }

            for (let i = 0; i < changeResultData.length; i++) {
              const row = changeResultData[i]
              row.rowNumber = rowNumber--
            }

            response.resultData = changeResultData
            return response
          },

          total: function (response) {
            return response.total
          },

          data: function (response) {
            // 카테고리 seq 순으로 배열 선언
            if (response.resultStatus.messageCode === '2000') {
              return response.resultData
            } else {
              kendo.alert('message: ' + response.resultStatus.messageText)
              return ''
            }
          }
        },
        error: function (e) {
          // console.log('error event handler', e.errors)
        }
      })
    },
    // 검색조건
    currentPageFilterOption: function() {
      const vm = this
      const refs = vm.$refs
      const currentSearchDataObj = {}

      // 회사
      if(refs.cmpyIdRef !== undefined){
        const cmpyId = refs.cmpyIdRef.kendoWidget().value()

        if(cmpyId !== undefined && cmpyId !== ''){
          currentSearchDataObj.cmpyId = cmpyId
        }
      }

      // 사업장
      if(refs.facilityRef !== undefined){
        const facilityId = refs.facilityRef.kendoWidget().value()

        if(facilityId !== undefined && facilityId !== ''){
          currentSearchDataObj.facilityId = facilityId
        }
      }
      // 거점
      if(refs.areaRef !== undefined){
        const areaId = refs.areaRef.kendoWidget().value()

        if(areaId !== undefined && areaId !== ''){
          currentSearchDataObj.areaId = areaId
        }
      }
      // 계정 권한
      if(refs.authRef !== undefined){
        let authId = refs.authRef.kendoWidget().current().index()

        if(authId <= 0) authId = ''
        if (authId !== undefined && authId !== '') {
          currentSearchDataObj.authId = vm.authList[authId].authId
        }
      }
      // 통합 검색
      if(refs.searchRef !== undefined){
        const search = refs.searchRef.kendoWidget().value()

        if(search !== undefined && search !== ''){
          currentSearchDataObj.search = search
        }
      }
      // 사용 여부
      if(refs.useYnRef !== undefined){
        let useYn = refs.useYnRef.kendoWidget().current().index()

        if(useYn <= 0) useYn = ''
        if(useYn !== undefined && useYn !== ''){
          currentSearchDataObj.useYn = vm.userStatusList[useYn].cdId
        }
      }

      return currentSearchDataObj.length === 0 ? undefined : currentSearchDataObj
    },
    onClickRefresh(data) {
      const vm = this
      vm.lastRenderingTime = EtnersParseUtil.convertDateToStringYYYYMMDDHHMISSFormat(
          new Date()
      );
      vm.$emit('refreshAll', true)
      vm.commonOnChangeEvent()
    },
    // 검색
    commonOnChangeEvent: function (e) {
      const vm = this
      const refs = vm.$refs

      if (vm.$refs.userListGridRef !== undefined) {
        const userListGridRef = vm.$refs.userListGridRef.kendoWidget()

        if (userListGridRef !== undefined) {
          const dataSource = vm.$refs.userListGridRef.kendoWidget().dataSource

          if (vm.lastRouteParams.page === undefined) {
            dataSource.page(1)
          } else {
            dataSource.read()
            this.lastRouteParams.page = undefined
          }
        }
      }
    },
    // 초기화
    cleanSearchDataEvent: function (e) {
      const vm = this
      const refs = vm.$refs

      if (refs.cmpyIdRef !== undefined) {
        refs.cmpyIdRef.kendoWidget().value('')
      }

      if (refs.facilityRef !== undefined) {
        refs.facilityRef.kendoWidget().value('')
      }
      if (refs.areaRef !== undefined) {
        refs.areaRef.kendoWidget().value('')
      }
      if (refs.authRef !== undefined) {
        refs.authRef.kendoWidget().select(0)
      }

      if (refs.searchRef !== undefined) {
        refs.searchRef.kendoWidget().value('')
      }
      refs.useYnRef.kendoWidget().select(0)

      vm.commonOnChangeEvent(e)
    },

    onChangeEventGrid: function (ev) {
      const vm = this
      const refs = vm.$refs

      if (!([0].includes(ev.sender._lastCellIndex))) {
        const selectedRow = ev.sender.select()
        const item = ev.sender.dataItem(selectedRow)
        const unqUserNo = item.unqUserNo

        vm.$router.push({
          name: 'UserDetail',
          params: {
            unqUserNo: unqUserNo
          }
        })
      }
    },

    onClickUserSave: function () {
      const vm = this
      vm.$router.push({
        name: 'UserSave'
      })
    }
  }
}
</script>

